module.exports = __webpack_public_path__ + "img/lindsay-lehr.9fcd18a3.png";